
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateLeaveTypePolicy, fetchLeaveTypesMaster } from "../../redux/actions/leaveTypeActions";
import { fetchDesignations } from "../../redux/actions/designationActions";

const CreateLeaveType = () => {
  const dispatch = useDispatch();
  const { creating, createError, masterLeaveTypes } = useSelector((state) => state.leaveType);
  const { designations, loading } = useSelector((state) => state.designation);

  const [description, setDescription] = useState("");
  const [policies, setPolicies] = useState([{ designation: "", total_leaves: "" }]);
  const [leaveTypeId, setLeaveTypeId] = useState("");

  useEffect(() => {
    dispatch(fetchDesignations());
    dispatch(fetchLeaveTypesMaster());
  }, [dispatch]);

  const handlePolicyChange = (index, field, value) => {
    const updated = [...policies];
    updated[index][field] = field === "total_leaves" ? Number(value) : value;
    setPolicies(updated);
  };

  const handleAddPolicy = () => {
    setPolicies([...policies, { designation: "", total_leaves: "" }]);
  };

  const handleRemovePolicy = (index) => {
    const updated = [...policies];
    updated.splice(index, 1);
    setPolicies(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!leaveTypeId.trim()) return;

    dispatch(updateLeaveTypePolicy(leaveTypeId, description, policies));
    setDescription("");
    setLeaveTypeId("");
    setPolicies([{ designation: "", total_leaves: "" }]);
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Update Leave Type Policy</h1>

        {createError && (
          <div className="bg-red-100 text-red-700 border border-red-300 px-4 py-2 rounded mb-4">
            Error: {typeof createError === "string" ? createError : "Something went wrong"}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Leave Type Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Leave Type <span className="text-red-500">*</span>
            </label>
            <select
              value={leaveTypeId}
              onChange={(e) => setLeaveTypeId(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
              required
            >
              <option value="">Select Leave Type</option>
              
              {masterLeaveTypes?.length > 0 ? (
  masterLeaveTypes
    .filter((type) => type?.id && type?.name)
    .map((type) => (
      <option key={type.id} value={type.id}>
        {type.name}
      </option>
    ))
) : (
  <option disabled>No leave types found</option>
)}

            </select>
          </div>

          {/* Description */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Description</label>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description"
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
            />
          </div>

          {/* Policies */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">Leave Policies</label>
            {policies.map((policy, index) => (
              <div key={index} className="mb-4 space-y-2 border p-4 rounded bg-gray-50">
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    Designation
                  </label>
                  <select
                    value={policy.designation}
                    onChange={(e) => handlePolicyChange(index, "designation", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
                    required
                  >
                    <option value="">Select Designation</option>
                    {loading ? (
                      <option disabled>Loading...</option>
                    ) : (
                      designations.map((d) => (
                        <option key={d} value={d}>
                          {d}
                        </option>
                      ))
                    )}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    Total Leaves
                  </label>
                  <input
                    type="number"
                    min="0"
                    value={policy.total_leaves}
                    onChange={(e) => handlePolicyChange(index, "total_leaves", e.target.value)}
                    placeholder="e.g. 5"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
                    required
                  />
                </div>

                {policies.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemovePolicy(index)}
                    className="text-red-600 text-sm mt-2 hover:underline"
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              onClick={handleAddPolicy}
              className="text-sm text-cyan-600 hover:underline mt-2"
            >
              + Add Another Designation
            </button>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={creating}
            className={`w-full px-4 py-2 text-white font-medium rounded-md transition ${
              creating ? "bg-gray-400 cursor-not-allowed" : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {creating ? "Updating..." : "Update Leave Type"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateLeaveType;




